/**
 * Extract a text preview from up to the first 3 sheets of an Excel/CSV file,
 * up to 100 rows per sheet, for IRL matching. Uses SheetJS (`xlsx`, already
 * a dep) — lighter than ExcelJS for read-only browser-side parsing.
 */
import * as XLSX from "xlsx";

const MAX_SHEETS = 3;
const MAX_ROWS_PER_SHEET = 100;
const MAX_CHARS = 4000;

export async function extractExcelPreview(file: File): Promise<string> {
  try {
    const buffer = await file.arrayBuffer();
    const wb = XLSX.read(buffer, { type: "array" });
    const sheetNames = wb.SheetNames.slice(0, MAX_SHEETS);

    const chunks: string[] = [];
    for (const name of sheetNames) {
      const sheet = wb.Sheets[name];
      if (!sheet) continue;
      const rows: any[][] = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        blankrows: false,
        defval: "",
      });
      const trimmed = rows.slice(0, MAX_ROWS_PER_SHEET);
      const text = trimmed
        .map((r) =>
          (Array.isArray(r) ? r : [])
            .map((c) => String(c ?? "").trim())
            .join("\t")
            .trimEnd(),
        )
        .filter((line) => line.length > 0)
        .join("\n");
      if (text) chunks.push(`[Sheet: ${name}]\n${text}`);
      if (chunks.join("\n\n").length > MAX_CHARS) break;
    }

    return chunks.join("\n\n").slice(0, MAX_CHARS);
  } catch (err) {
    console.warn(`[irl-match] Excel extraction failed for "${file.name}":`, err);
    return "";
  }
}
